import { createBrowserHistory } from 'history';
const appHistory = createBrowserHistory({basename : (process.env.REACT_APP_ROUTER_BASE || "")});
appHistory.pushLater = (...args) => setImmediate(() => appHistory.push(...args));
export default appHistory;